
import { Component, Vue } from 'vue-property-decorator'
import DatePicker from "@/components/date-picker.vue";
import lsPagination from "@/components/ls-pagination.vue";
import { RequestPaging } from '@/utils/util'
import { GoodsOrderType, SettlementType } from '@/utils/type'
import { apiPlatformBill } from '@/api/operating/group_welfare/order'
@Component({
  components: {
    DatePicker,
    lsPagination
  }
})
export default class PlatformBill extends Vue {
  /** S Data*/
  activeName: any = 'all_count'
  form:any = {
    start_time: '',
    end_time: ''
  }
  tabs = [
    {
      label: '全部',
      name: SettlementType[0]
    },
    {
      label: '待结算',
      name: SettlementType[1]
    },
    {
      label: '已结算',
      name: SettlementType[2]
    },
    {
      label: '已退款',
      name: SettlementType[3]
    },
  ]
  
  index = 0
  
  pager = new RequestPaging()
  
  tabCount = {
    all_count: 0, //全部
    wait_count: 0, //待结算
    end_count: 0, //已结算
    refund_count: 0, //已退款
  }
  /** E Data*/
  /** S Methods*/
  // 获取订单信息
  getLists(page?: number) {
    page && (this.pager.page = page)
    let status: any = this.activeName == 'all_count' ? '' : SettlementType[this.activeName]
    this.pager
      .request({
        callback: apiPlatformBill,
        params: {
          status: status == '' ? '' : status - 1,
          ...this.form
        }
      })
      .then(res => {
        this.tabCount = res?.extend
      })
  }
  
  // 重置搜索
  reset() {
    Object.keys(this.form).map(key => {
      this.$set(this.form, key, '')
    })
    this.getLists()
  }
  /** E Methods*/
  created() {
    this.getLists(1)
  }
}
